export default () => {
  const $examples = $('.examples');

  if ($examples.length === 0) {
    return;
  }

  const $examplesDesktop = $('.examples-desktop');
  const $examplesMobile = $('.examples-mobile');

  if ($examplesDesktop.hasClass('slick-initialized')) {
    $examplesDesktop.slick('unslick');
  }

  if ($examplesMobile.hasClass('slick-initialized')) {
    $examplesMobile.slick('unslick');
  }

  const $controlsWrapper = $('.examples-controls');
  $controlsWrapper.empty();



  if (window.matchMedia('(min-width: 992px)').matches) {
    $examplesDesktop.slick({
      infinite: true,
      fade: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
      autoplay: true,
      autoplaySpeed: 3000,
      pauseOnDotsHover: true,
      prevArrow: "<button type='button' class='slider-btn slider-btn--prev'><svg class='icon slider-btn__icon'><use xlink:href='img/sprite-svg/sprite.svg#location-arrow'></use></svg></button>",
      nextArrow: "<button type='button' class='slider-btn slider-btn--next'><svg class='icon slider-btn__icon'><use xlink:href='img/sprite-svg/sprite.svg#location-arrow'></use></svg></button>",
      // lazyLoad: 'ondemand',
      // appendArrows: $controlsWrapper,
      appendDots: $controlsWrapper,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            adaptiveHeight: false,
            autoplay: false,
          },
        },
      ],
    });

    return;
  }



  $examplesMobile.slick({
    infinite: true,
    fade: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    autoplay: true,
    autoplaySpeed: 3000,
    adaptiveHeight: true,
    pauseOnDotsHover: true,
    appendDots: $controlsWrapper,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          adaptiveHeight: false,
          autoplay: false,
        },
      },
    ],
  });
};
